<template>
  <div class="flex flex-col">
    <div class="flex justify-between items-center mb-1">
      <span class="text-sm text-gray-600 dark:text-gray-400">{{ label }}</span>
      <span class="text-sm font-medium text-gray-900 dark:text-gray-100">
        {{ formatValue(value) }}{{ unit }}
        <span v-if="target" class="text-gray-400 dark:text-gray-500">
          / {{ formatValue(target) }}{{ unit }}
        </span>
      </span>
    </div>
    <div v-if="target" class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
      <div
        class="h-2 rounded-full transition-all duration-300"
        :class="progressBarClass"
        :style="{ width: `${Math.min(progressPercent, 100)}%` }" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  value: {
    type: Number,
    required: true
  },
  target: {
    type: Number,
    default: null
  },
  unit: {
    type: String,
    default: ''
  }
})

const progressPercent = computed(() => {
  if (!props.target || props.target === 0) return 0
  return (props.value / props.target) * 100
})

const progressBarClass = computed(() => {
  const percent = progressPercent.value
  if (percent >= 100) {
    return 'bg-green-500'
  } if (percent >= 75) {
    return 'bg-blue-500'
  } if (percent >= 50) {
    return 'bg-yellow-500'
  }
  return 'bg-gray-400'
})

const formatValue = (val) => {
  if (val == null) return '0'
  // Show decimal for small values, round for large values
  if (val < 10) {
    return val.toFixed(1)
  }
  return Math.round(val).toString()
}
</script>
